module.exports = ".mat-table {\n  overflow: auto;\n  max-height: 100%; }\n\n.estilo_tabla {\n  width: 100% !important;\n  height: 100% !important; }\n\n.mat-header-cell {\n  font-size: 16px;\n  font-weight: bold; }\n\n.example-header {\n  min-height: 64px;\n  padding: 8px 24px 0; }\n\n.mat-form-field {\n  font-size: 14px;\n  width: 100%; }\n\n.btn-actions {\n  border: none;\n  overflow: hidden; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administracion/fondeadores/fondeadores.component.scss
// module id = ./src/app/administracion/fondeadores/fondeadores.component.scss
// module chunks = main